import { render, staticRenderFns } from "./TanUpdateOtp.vue?vue&type=template&id=5cfa0f66&scoped=true&"
import script from "./TanUpdateOtp.vue?vue&type=script&lang=js&"
export * from "./TanUpdateOtp.vue?vue&type=script&lang=js&"
import style0 from "./TanUpdateOtp.vue?vue&type=style&index=0&id=5cfa0f66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cfa0f66",
  null
  
)

export default component.exports